import axios from 'axios';

import type { IAuthServiceListener } from '@sine/auth-client';
import { TeamSwitcherInterceptor, TeamSwitcherService } from '@sine/sine-team-switcher';

import { storage } from '../services/storage/storage.service';
import currentTeamListener from './currentTeamListener';
import teamScopingService from './teamScoping.service';

const teamSwitcherService = new TeamSwitcherService(teamScopingService.teamsCallback, storage);
teamSwitcherService.addCurrentTeamListener(currentTeamListener);

export const teamSwitcherInterceptor = new TeamSwitcherInterceptor(axios, teamSwitcherService, [
  // Multiregion or global endpoints that must not have teamId when requesting
  'appointee/mine',
  'auth/mfa',
  'host/mine',
  'user/search',
  'user/search/bysite',
  'passes/mine',
]);
teamSwitcherInterceptor.startIntercepting();

/**
 * Wait until the auth service has got a logged in user and then initialise the team service.
 * If the logged in user changes (for some reason) then initialise again!
 */
let initialisedUserId: string | undefined;

const handleAuthStateChange: IAuthServiceListener['func'] = async ({ authState, userDetails }) => {
  if (authState === 'loggedIn' && (!initialisedUserId || initialisedUserId !== userDetails?.id)) {
    initialisedUserId = userDetails?.id;
    await teamSwitcherService.reinitialise();
    teamSwitcherInterceptor.startIntercepting();
  } else {
    initialisedUserId = undefined;
  }
};

let isAuthListenerRegistered = false;

export async function registerAuthListener() {
  if (isAuthListenerRegistered) return;
  isAuthListenerRegistered = true;

  const { default: authService } = await import('../authentication/auth.service');

  handleAuthStateChange(authService.getAuthState());
  authService.addAuthStateListener(handleAuthStateChange);
}

export default teamSwitcherService;
